<template>
  <div id="app" :class="{'mobile': $vuetify.breakpoint.xs}" >
    <v-app>
      <v-container v-if="!($vuetify.breakpoint.xs || isMobile())" class="pa-0 header d-none d-md-flex" style="color:grey;"><div style="float:left;"><span :class="$i18n.locale=='en'?'language-option-disabled':'language-option'" v-on:click="changeLanguage('en')">E N G</span><span class="lang_divider">/</span><span :class="$i18n.locale=='zh_TW'?'language-option-disabled':'language-option'" v-on:click="changeLanguage('zh_TW')">中</span></div></v-container>
      <v-container class="pa-0 header d-flex">
        <div class="d-flex" v-if="!($vuetify.breakpoint.xs || isMobile())">
          <v-menu v-for="m in menu" :key="m.title" open-on-hover bottom offset-y >
            <template v-slot:activator="{ on, attrs }">
              <div
                dark
                class="d-inline-flex float-left menuItem menufont"
                v-bind="attrs"
                v-on="on"
              >
                <span :class="$i18n.locale=='en'?'DinCond menufont':'MHeiHK'" 
                  style="color:white;"
                  v-on:click="goto(m.routerName, m.params)"
                >
                  {{m.title}}
                </span>
              </div>
            </template>
            <v-list 
              color=black
              v-if="m.submenu.length"
            >
                <div
                  v-for="ms in m.submenu"
                  :key="ms.title"
                  class="d-flex subMenuItem"
                >
                  <!-- <div
                    class="menufont"
                    style="color:white;margin-left: 17px;"
                    v-on:click="goto(ms.routerName, ms.params, ms.hash)">
                      {{ ms.title }}
                  </div> -->
                  <span
                    style="color:white;margin-left: 17px;"
                    class="menufont"
                    v-on:click="goto(ms.routerName, ms.params, ms.hash)"
                  >
                    {{ ms.title }}
                  </span>
                  <!-- <router-link
                    class="menufont"
                    style="color:white;margin-left: 17px;"
                    :to="{path:ms.link}">
                      {{ ms.title }}
                  </router-link> -->
                </div>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex" v-if="$vuetify.breakpoint.xs || isMobile()">
          <v-icon v-if="!mobileMenu" v-on:click="mobileMenu=true" style="cursor:pointer;color:white;margin-left: 17px;" size=36>mdi-menu</v-icon>
          <div v-if="mobileMenu" class="font-size-XL" style="width:100%;max-width: 414px;background:black;color:white;position:fixed;top:0px;left:0;padding:46px 46px 20px 46px;z-index:50;">
            <div class="d-flex" style="margin-bottom:20px;">
              <v-icon v-on:click="mobileMenu=false" style="float:left;color:white;margin-left: -12px;" size=36>mdi-close</v-icon>
              <div style="float:left;margin-left:auto;"><span :class="$i18n.locale=='en'?'language-option-disabled':'language-option'" v-on:click="changeLanguage('en')">E N G</span><span class="lang_divider">/</span><span :class="$i18n.locale=='zh_TW'?'language-option-disabled':'language-option'" v-on:click="changeLanguage('zh_TW')">中</span></div>
            </div>
            <div class="d-flex flex-column" v-for="(m, i) in menu" :key=i>
              <div class="d-flex" style="padding-bottom:15px; padding-top:30px">
                <span 
                  :class="$i18n.locale=='en'?'DinCond':'NotoSerifTC'" 
                  style="color:white;"
                  class="menufont"
                  v-on:click="goto(m.routerName, m.params)"
                >
                  {{m.title}}
                </span>
                <span :class="{displaynone: !m.submenu.length}" style="float:left;margin-left:auto;margin-top:-3px;" v-on:click="mobileMenu==m.routerName?mobileMenu=true:mobileMenu=m.routerName">
                  >
                </span>
              </div>
              <div class="d-flex" v-for="(sm, i) in m.submenu" :key=i>
                <span class="text-justify menufont" style="margin-left:16px; padding-bottom:10px" v-if="mobileMenu==m.routerName"
                  :class="$i18n.locale=='en'?'DinCondL':'NotoSerifTC'" 
                    v-on:click="goto(sm.routerName, sm.params)">
                  {{sm.title}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <router-link to="/" class="logo">
          <v-img class="logo"
            contain
            src="/logo.png">
          </v-img>
        </router-link>
      </v-container>
      <router-view style="margin-top: 10px;"/>
      <v-container class="footer pa-0" style="z-index:0;">
        <v-divider style="border-color: white;"></v-divider>
        <v-row class="ma-0 footer-padding">
          <div v-if="!$vuetify.breakpoint.xs" :class="$i18n.locale=='en'?'DinCondL':'MHeiHK'" class="footer-links">
            <div class="links" v-on:click="goto('Our Company', null)">{{ $t('menu.our_company.title')}}</div>
            <div class="links" v-on:click="goto('Our Products', null)">{{ $t('menu.our_products.title')}}</div>
            <div class="links" v-on:click="goto('Affiliate Info', {affiliate_id: 1})">{{ $t('menu.our_affiliates.title')}}</div>
          </div>
          <div v-if="!$vuetify.breakpoint.xs" :class="$i18n.locale=='en'?'DinCondL':'MHeiHK'" class="footer-links">
            <div class="links" v-on:click="goto('Kitchen Recipe', {kitchen_id: 1})">{{ $t('menu.our_recipes.title')}}</div>
            <div class="links" v-on:click="goto('News', {affiliate_id: 1})">{{ $t('menu.news.title')}}</div>
            <div class="links" v-on:click="goto('Contact Us', {})">{{ $t('menu.contact_us.title')}}</div>
          </div>
          <div v-if="!$vuetify.breakpoint.xs" :class="$i18n.locale=='en'?'DinCondL':'MHeiHK'" class="footer-info">
            <div class="infos" v-html="$t('footer.address')"></div>
            <div class="infos">{{ $t('footer.tel')}} | {{ $t('footer.fax')}}</div>
            <div class="infos" v-html="$t('footer.email')"></div>
          </div>
          <div v-if="$vuetify.breakpoint.xs" :class="$i18n.locale=='en'?'DinCondL':'MHeiHK'" class="footer-info">
            <div class="infos text-center" v-html="$t('footer.address').replaceAll('<br>','')"></div>
            <div class="infos text-center" v-html="$t('footer.tel')+' | '+$t('footer.fax')"></div>
            <div class="infos text-center" v-html="$t('footer.email')"></div>
          </div>
        </v-row>
        <v-row>
          <v-col class="credit">
            {{ $t('footer.credit')}}
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
  export default {
    data:function () {
      return {
        mobileMenu: false,
        menu:[
          {
            title: this.$i18n.t('menu.our_company.title'),
            routerName: "Our Company",
            params: {},
            submenu:[
              {
                title: this.$i18n.t('menu.our_company.submenu.about_us'),
                routerName: "Our Company",
                params: {},
                hash: "#about-us"
              },
              // {
              //   title: this.$i18n.t('menu.our_company.submenu.our_leadership'),
              //   routerName: "Our Company",
              //   params: {},
              //   hash: "#our-leadership"
              // },
              {
                title: this.$i18n.t('menu.our_company.submenu.our_services'),
                routerName: "Our Company",
                params: {},
                hash: "#our-services"
              },
              {
                title: this.$i18n.t('menu.our_company.submenu.out_logos'),
                routerName: "Our Company",
                params: {},
                hash: "#our-logos"
              }
            ]
          },
          {
            title: this.$i18n.t('menu.our_products.title'),
            routerName: "Our Products",
            params: {},
            submenu:[
              {
                title: this.$i18n.t('menu.our_products.submenu.dairy_product'),
                routerName: "Product Info",
                params: {pid: 1},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.han_and_salami'),
                routerName: "Product Info",
                params: {pid: 2},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.truffle_and_mushroom'),
                routerName: "Product Info",
                params: {pid: 3},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.oil_and_vinegar'),
                routerName: "Product Info",
                params: {pid: 4},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.grain_product'),
                routerName: "Product Info",
                params: {pid: 5},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.nuts_snacks_and_rice'),
                routerName: "Product Info",
                params: {pid: 6},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.sauce_and_seasoning'),
                routerName: "Product Info",
                params: {pid: 7},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.tomatoes_and_preserved_product'),
                routerName: "Product Info",
                params: {pid: 8},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.beverage'),
                routerName: "Product Info",
                params: {pid: 9},
              },
              {
                title: this.$i18n.t('menu.our_products.submenu.our_valued_partners'),
                routerName: "Our Products",
                params: {},
                hash: "#our-valued-partners"
              }
            ]
          },
          {
            title: this.$i18n.t('menu.our_affiliates.title'),
            routerName: "Affiliate Info",
            params: {affiliate_id: 1},
            submenu:[
              {
                title: this.$i18n.t('menu.our_affiliates.submenu.primo_mart'),
                routerName: "Affiliate Info",
                params: {affiliate_id: 1},
              },
              // {
              //   title: this.$i18n.t('menu.our_affiliates.submenu.shenzhen_zhengran_food'),
              //   routerName: "Affiliate Info",
              //   params: {affiliate_id: 2},
              // }
              // ,{
              //   title: this.$i18n.t('menu.our_affiliates.submenu.amare'),
              //   routerName: "Affiliate Info",
              //   params: {affiliate_id: 3},
              // },
              {
                title: this.$i18n.t('menu.our_affiliates.submenu.my_foundation'),
                routerName: "Affiliate Info",
                params: {affiliate_id: 4},
              }
            ]
          },{
            title: this.$i18n.t('menu.our_recipes.title'),
            routerName: "Kitchen Recipe",
            params: {kitchen_id: 1},
            submenu:[
              {
                title: this.$i18n.t('menu.our_recipes.submenu.lorence_kitchen'),
                routerName: "Kitchen Recipe",
                params: {kitchen_id: 1},
              },
              {
                title: this.$i18n.t('menu.our_recipes.submenu.pm_kitchen'),
                routerName: "Kitchen Recipe",
                params: {kitchen_id: 2},
              }
            ]
          },{
            title: this.$i18n.t('menu.news.title'),
            routerName: "News",
            params: {affiliate_id: 1},
            submenu:[{
                title: this.$i18n.t('menu.news.submenu.lorence'),
                routerName: "News",
                params: {affiliate_id: 1},
              },{
              //   title: this.$i18n.t('menu.news.submenu.amare'),
              //   routerName: "News",
              //   params: {affiliate_id: 2},
              // },{
                title: this.$i18n.t('menu.news.submenu.my_foundation'),
                routerName: "News",
                params: {affiliate_id: 3},
              }
            ]
          },{
            title: this.$i18n.t('menu.contact_us.title'),
            routerName: "Contact Us",
            params: {},
            submenu:[
            ]
          }
        ],
      }
    },
    methods: {
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
      goto: function(routerName, params, hash=null){
        if(hash){
          this.$router.replace({ name: routerName, params: params, hash: hash});
        }else{
          this.$router.replace({ name: routerName, params: params});
        }
        if(routerName==this.$router.history.current.name){
          location.reload();
        }
      },
      changeLanguage: function(newLang){
        console.log(newLang)
        if(newLang!=this.$i18n.locale){
          localStorage.setItem('language', newLang)
          location.reload();
        }
      }
    },
  }
</script>

<style lang="scss">
.displaynone{
  opacity: 0;
}
a.mailto{
  color:white !important;
}
a.mailto:hover{
  color:mediumseagreen !important;
}

#hpslider .slick-slide{
  margin-left:10px !important;
  margin-right:10px !important;
}

.mobile #hpslider .slick-slide{
  margin-left:2px !important;
  margin-right:2px !important;
}

.slick-slide img{
  width: 100%;
}

.language-option{
  cursor: pointer;
  letter-spacing: 5px;
  letter-spacing: -0.5px;
}

.language-option:hover{
  color: mediumseagreen;
}

.language-option-disabled{
  cursor: default;
  border-bottom: 1px solid grey;
  padding-bottom: 3px;
  letter-spacing: -0.5px;
}

.slick-dots{
  display: inline-block !important;
  margin-left:auto !important;
  width: auto !important;
  right:4px !important;
}

#product-carousel .slick-dots{
  bottom: 5% !important;
}

#affiliate-carousel .slick-dots{
  bottom: -10% !important;
}

.mobile #affiliate-carousel .slick-dots{
  bottom: 10% !important;
}

#kitchen-carousel .slick-dots{
  bottom: -2% !important;
}

#kitchen-carousel .slick-dots{
  bottom: 5% !important;
}

.slick-dots li{
  display: block !important;
}
@font-face {
  font-family: "Georgia";
  src: local("Georgia"),
   url(./fonts/Georgia-Regular-font.ttf) format("truetype");
}
@font-face {
  font-family: "DinCond";
  src: local("DinCond"),
   url(./fonts/DINCond-Regular.otf) format("opentype");
}
@font-face {
  font-family: "DinCondL";
  src: local("DinCondL"),
   url(./fonts/DINCond-Light.otf) format("opentype");
}

@font-face {font-family: "MHeiHK";
    src: url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.eot"); /* IE9*/
    src: url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
    url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.woff2") format("woff2"), /* chrome firefox */
    url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.woff") format("woff"), /* chrome firefox */
    url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.ttf") format("truetype"), /* chrome firefox opera Safari, Android, iOS 4.2+*/
    url("https://db.onlinewebfonts.com/t/1cd90503ccb8043031bf87c4e45d53d7.svg#MHeiHK") format("svg"); /* iOS 4.1- */
}
@font-face{
  font-family: "DinCondB";
  src: local("DinCondB"),
   url(./fonts/d-din.condensed-bold.ttf) format("truetype");
}

@font-face {
  font-family: "MHeiHKSM";
  src: local("MHeiHKSM"),
   url(./fonts/MHeiHKS-Medium.OTF) format("opentype");
}

@font-face {
  font-family: "DFHuaZongHK";
  src: local("DFHuaZongHK"),
   url(./fonts/DFHuaZongHK-W5.otf) format("opentype");
}


@font-face {
  font-family: "NotoSerifTC";
  src: local("NotoSerifTC"),
   url(./fonts/MHeiHK-Bold.OTF) format("opentype");
}

@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@600&display=swap');

body{
  background: #132b1b;
}

#app{
  padding-top: 15px;
}

.footer-padding{
  padding-top: 40px;
}

.footer-padding{
  padding-top:40px;
}
.mobile .footer-padding{
  padding-top: 20px;
}

.showfromtop{
  position: absolute;
  height: 100%;
  bottom:0;
  left:0;
  right:0;
  background-color: inherit;
  transition: top 2s ease-out;
}

.showfromtop-show{
  top:100%;
}

.showfromtop-nobg{
  max-height: 0px !important;
  overflow: hidden;
  transition: max-height 10s ease-out;
}

.showfromtop-nobg-show{
  max-height: 1000px !important;
}

[data-aos="custom-title-fade-in"] {
  position:absolute;
  top: 36%;
  width: 100%;
  opacity: 0;
  transition-property: top, opacity;
  &.aos-animate {
    top: 0%;
    opacity: 1;
  }
}

[data-aos="showfromtop"] {
  max-height: 0 ;
  overflow: hidden;
  transition-property: max-height;
  &.aos-animate {
    max-height: 100% ;
  }
}

[data-aos="showfromtopNobg"] {
  max-height: 0 ;
  overflow: hidden;
  transition-property: max-height;
  &.aos-animate {
    max-height: 70px ;
  }
}

[data-aos="showupeffect"] {
  opacity: 0;
  transform: translateY(70%);
  transition-property: opacity, transform;
  &.aos-animate {
    opacity: 1;
    transform: translateY(0%);
  }
}

[data-aos="showeffect"] {
  height: 100%;
  transition-property: height;
  &.aos-animate {
    height: 0;
  }
}

[data-aos="showeffect2"] {
  height: 95%;
  transition-property: height;
  &.aos-animate {
    height: 5%;
  }
}

[data-aos="custom-fade"] {
  opacity: 0;
  transition-property: opacity;
  &.aos-animate {
    opacity: 1;
  }
}

.black-theme{
  position: relative;
  background: black;
}

.white-theme{
  position:relative;
  background:white;
}

.white-theme-font{
  color :#19442A;
}

.white-theme-border{
  border-color :#19442A;
}

.green-theme{
  position: relative;
  background:#19442A;
}

.green-theme-font{
  color :white;
}

.green-theme-border{
  border-color :white;
}

.default-theme{
  position: relative;
  background:#132b1b;
}

.menufont {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

@media (min-width: 375px) {
  .font-size-XXL {
      font-size: 18px;
  }

  .homepage-slogan-font-size {
    font-size: 10px;
  }

  .homepage-slogan-font-size-chi {
    font-size: 14px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .fontsizeaffiliateaddress-chi {
    font-size: 14px;
    padding-bottom: 5px;
    padding-top:5px;
  }
 .font-size-s6 {
   font-size:12px;
 }

 .moblienewsdate {
   font-size:10px;
 }

 .newsdate {
   font-size:9px;
 }

}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .font-size-XXL {
      font-size: 24px;
  }
  
  .font-size-XL {
      font-size: 18px;
  }

  .font-size-l4-chi {
    font-size: 12px;
  }

  .font-size-l3-chi {
    font-size: 20px;
  }

  .font-size-l1 {
      font-size: 16px;
  }
  .font-size-l2 {
      font-size: 14px;
  }
  .font-size-l3 {
      font-size: 12px;
  }
  .font-size-l4 {
      font-size: 12px;
  }
  .font-size-s1 {
      font-size: 12px;
  }
  .font-size-s2 {
      font-size: 10px;
  }
  .font-size-s3 {
      font-size: 7px;
  }
  .font-size-s4 {
      font-size: 4px;
  }
  .homepage-slogan-font-size {
    font-size: 14px;
  }

    .font-size-s6 {
    font-size: 16px;
  }

   .newsdate {
   font-size:9px;
 }
  
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .menufont {
    font-size:20px
  }
  
  .font-size-XXL {
      font-size: 28px;
  }
  
  .font-size-XL {
      font-size: 20px;
  }
  
  .font-size-L{
      font-size: 15px;
  }

  .font-size-l1 {
      font-size: 18px;
  }
  .font-size-l2 {
      font-size: 16px;
  }
  .font-size-l3 {
      font-size: 16px;
  }

  .font-size-l3-chi {
    font-size: 20px;
  }
  .font-size-l4 {
      font-size: 14px;
  }
  .font-size-s1 {
      font-size: 15px;
  }
  .font-size-s1-chi {
      font-size: 20px;
  }

  .homepage-slogan-font-size {
    font-size: 15px;
  }

  .homepage-slogan-font-size-chi {
    font-size: 20px;
  }
  .font-size-s6 {
    font-size: 16px;
  }
  .font-size-s2 {
      font-size: 10px;
  }
  .font-size-s3 {
      font-size: 7px;
  }
  .font-size-s4 {
      font-size: 18px;
  }

  .font-size-s4-chi {
      font-size: 18px;
  }
  
  .font-size-s7 {
    font-size: 14px;
  }

  .font-size-XXL-chi {
      font-size: 28px;
  }

  .fontsizeaffiliateaddress-chi {
    font-size: 14px;
  }

  .footer-padding{
  padding-left: 20px;
  padding-top: 40px;
  }
}
  

// Large devices (desktops, 992px and up)
@media (min-width: 992px) { 
  .menufont {
    font-size:20px
  }
  
  //English Tilte for our company, our product, affiliate Gallery, our recipes
  .font-size-XXL {
      font-size: 25px;
  }

  .font-size-XXL-chi {
      font-size: 28px;
  }
  

  //Englsih Content for our company
  .font-size-XL {
      font-size: 16px;
  }

  .font-size-L{
      font-size: 15px;
  }
  

  //English FOUNDER name for our company
  .font-size-l1 {
      font-size: 15px;
  }


  // Address, telephone and social media for our affiliates
  // content for homepage
  // content for our company
  .font-size-l2 {
      font-size: 15px;
  }

  // Title for homepage, News, Contact Us Company name
  .font-size-l3 {
      font-size: 23px;
  }

  .font-size-l3-chi {
      font-size: 23px;
  }

  // content for homepage
  .font-size-l4 {
      font-size: 15px;
  }

    .font-size-l4-chi {
      font-size: 12px;
      letter-spacing: 5px;
  }

  // Button and tagline for homepage
  // Our affiliate store address
  // Social Media link
  // Contact us title and submit button
  .font-size-s1 {
      font-size: 15px;
  }

  .homepage-slogan-font-size {
    font-size: 15px;
  }

  .font-size-s1 {
      font-size: 18px;
  }

  .homepage-slogan-font-size-chi {
    font-size: 18px;
  }

  // tagline for our product, New name
  // contact Us information
  .font-size-s2 {
      font-size: 10px;
  }

  // text of overlay for our product
  .font-size-s3 {
      font-size: 32px;
  }

  // Store name for our affiliates
  .font-size-s4 {
      font-size: 20px;
  }

  .font-size-s4-chi {
      font-size: 20px;
  }

 // Button for our affiliate
   .font-size-s5 {
      font-size: 14px;
  }
  
  .font-size-s5-chi {
      font-size: 12px;
  }


  // Event & gallery name and date for our affiliates
  // News date
  // Event, gallery and videos title and date for our affiliates, our recipes, new date
  .font-size-s6 {
      font-size: 10px;
  }

  // news>event name
  .font-size-s7 {
      font-size: 14px;
  }

  .font-size-s7-chi {
      font-size: 14px;
  }

  .fontsizeaffiliateaddress-chi{
   font-size :15px;
   letter-spacing: 3px;
  } 

}

// Extra large devices (large desktops, 1264px and up)
@media (min-width: 1264px) {
  .menufont {
    font-size:16px
  }
  
  //English Tilte for our company, our product, affiliate Gallery, our recipes
  .font-size-XXL {
      font-size: 30px;
  }

  .font-size-XXL-chi{
      font-size: 30px;
  }
  

  //Englsih Content for our company
  .font-size-XL {
      font-size: 18px;
  }

  .font-size-L{
      font-size: 18px;
  }
  

  //English FOUNDER name for our company
  .font-size-l1 {
      font-size: 18px;
  }


  // Address, telephone and social media for our affiliates
  // content for homepage
  // content for our company
  .font-size-l2 {
      font-size: 18px;
  }

  // Title for homepage, News, Contact Us Company name
  .font-size-l3 {
      font-size: 25px;
  }

  .font-size-l3-chi {
      font-size: 25px;
  }

  // content for homepage
  .font-size-l4 {
      font-size: 18px;
  }

    .font-size-l4-chi {
      font-size: 15px;
      letter-spacing: 5px;
  }

  // Button and tagline for homepage
  // Our affiliate store address
  // Social Media link
  // Contact us title and submit button
  .font-size-s1 {
      font-size: 18px;
  }
  .homepage-slogan-font-size {
    font-size: 18px;
  }

  .font-size-s1-chi {
   font-size: 21px;
  }

  .homepage-slogan-font-size-chi {
    font-size: 21px;
  }

  // tagline for our product, New name
  // contact Us information
  .font-size-s2 {
      font-size: 15px;
  }

  // text of overlay for our product
  .font-size-s3 {
      font-size: 36px;
  }

  // Store name for our affiliates
  .font-size-s4 {
      font-size: 23px;
  }

    .font-size-s4-chi {
      font-size: 23px;
  }

 // Button for our affiliate
   .font-size-s5 {
      font-size: 14px;
  }

  .font-size-s5-chi {
      font-size: 14px;
  } 

  // Event & gallery name and date for our affiliates
  // News date
  // Event, gallery and videos title and date for our affiliates, our recipes, new date
  .font-size-s6 {
      font-size: 14px;
  }

  // news>event name
  .font-size-s7 {
      font-size: 16px;
  }
  .font-size-s7-chi {
      font-size: 16px;
  }

  .fontsizeaffiliateaddress-chi{
    font-size :18px;
    letter-spacing: 3px;
  }  
}

@media (min-width: 1904px){
  .menufont {
    font-size:16px
  }
  
  //English Tilte for our company, our product, affiliate Gallery, our recipes
  .font-size-XXL {
      font-size: 35px;
  }
  
  .font-size-XXL-Chi {
      font-size: 35px;
  }

  //Englsih Content for our company
  .font-size-XL {
      font-size: 23px;
  }
  .font-size-L{
      font-size: 23px;
  }
  

  //English FOUNDER name for our company
  .font-size-l1 {
      font-size: 25px;
  }

  //address, telephone and social media for our affiliates
  .font-size-l2 {
      font-size: 17px;
  }

  // Title for homepage, News, Contact Us Company name
  .font-size-l3 {
      font-size: 30px;
  }

   .font-size-l3-chi {
      font-size: 30px;
  }

  // content for homepage
  .font-size-l4 {
      font-size: 21px;
  }

  .font-size-l4-chi {
      font-size: 20px;
      letter-spacing: 5px;
  }

  // tagline for homepage
  // Our affiliate store address
  // Social Media link
  // Contact us title and submit button
  .font-size-s1 {
      font-size: 20px;
  }

  .homepage-slogan-font-size {
    font-size: 20px;
  }

  .font-size-s1-chi {
      font-size: 23px;
  }

  .homepage-slogan-font-size-chi {
    font-size: 23px;
  }

  // tagline for our product, New name
  // contact Us information
  .font-size-s2 {
      font-size: 18px;
  }

  // text of overlay for our product
  .font-size-s3 {
      font-size: 40px;
  }

  // Store name for our affiliates
  .font-size-s4 {
      font-size: 26px;
  }

  .font-size-s4-chi {
      font-size: 26px;
  }

 // Button for our affiliate
   .font-size-s5 {
      font-size: 14px;
  }

    .font-size-s5-chi {
      font-size: 16px;
  } 

  // Event & gallery name and date for our affiliates
  // Event, gallery and videos title and date for our affiliates, our recipes, new date
  .font-size-s6 {
      font-size: 16px;
  }

  // news>event name
  // news>read more button
  .font-size-s7 {
      font-size: 18px;
  }

  .font-size-s7-chi {
      font-size: 18px;
  }

  .fontsizeaffiliateaddress-chi{
    font-size:20;
    letter-spacing: 3px;
  }

  .container {
      max-width: 1400px!important;
  }
}
#app {
  font-family: "DinCond", Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #132b1b;
}

#nav{
  padding: 50px 30px 30px 10px;
}

.logo{
  width:15%;
  min-width:200px;
  margin-left:auto;
}

.mobile .logo{
  width:15%;
  min-width:140px;
  margin-left:auto;
  margin-right:30px;
}

.DinCondL{
  font-family: "DinCondL", Helvetica, Arial !important;
}

.MHeiHK{
  font-family: 'MHeiHK';
}


.DinCond{
  font-family: "DinCond";
}

.menuItem {
  position: relative; 
  margin-top: auto;
  color: white !important;
  margin-right: 40px;
  padding-bottom: 13px;
  letter-spacing: 2px;
  font-size: 16px;
  font-family: 'dincond';
}

.menuItem > span{
  padding-bottom:5px;
}

.v-menu__content{
  border-radius: 0px !important;
}

.lang_divider{
  margin-right:10px;
  margin-left:10px;
}

.menuItem> span:after {
  display:block;
  content: '';
  margin-top:5px;
  border-bottom: solid 1px white;  
  transform: scaleX(0);  
  transition: transform 250ms ease-in-out;
  border-radius: 0;
}

.menuItem> span:hover:after { 
  transform: scaleX(1);
  border-radius: 0;
   }

.subMenuItem {
  color: white !important;
  margin-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  letter-spacing: 2px;
  font-size: 16px;
  font-family: 'dincond';
}

.subMenuItem > span{
  padding-bottom: 5px;
  border-radius: 0;
  text-transform:capitalize;
}

.subMenuItem> span:after {
  display:block;
  content: '';
  border-bottom: solid 1px white;  
  transform: scaleX(0);
  margin-top:5px;
  transition: transform 250ms ease-in-out;
  border-radius: 0;
}

.subMenuItem> span:hover:after { 
  transform: scaleX(1); 
  border-radius: 0;
  }

a {
  text-decoration: none;
}
.footer{
  margin-top:0px ;
}

.footer-links{
  float: left;
  margin-right: 60px;
}

.footer-info{
  margin-left: auto;
}

.links{
  text-align: left;
  color: white !important;
  letter-spacing: 3px;
  font-size: 16px;
  text-decoration: none;
}

.links:hover{
  color: #1d953b !important;
  cursor: pointer;
}

.footer-links .links{
  margin-bottom: 20px;
}

.infos{
  font-size: 15px;
  text-align: left;
  color: white;
  line-height: 1.5;
  letter-spacing: 2px;
  font-weight: 100;
  margin-bottom: 2px;
}

.mobile .footer-info{
  margin: auto;
}

.mobile .infos{
  font-size: 10px;
  text-align: left;
  color: white;
  line-height: 1.5;
  letter-spacing: 1px;
  font-weight: 100;
  margin-bottom: 2px;
}

.mobile .infos .links{
  font-size: 10px;
}



.mobile .credit{
  font-size: 8px;
  letter-spacing: 1px;
}

.contentl{
  font-family: 'MHeihk';
  letter-spacing: 3px;
  color: white;
  height: 35%;
}

.contents{
  letter-spacing: 2px;
}

.button{
  margin: auto;
  margin-top: 13px;
  padding: 5px 20px;
  color: green;
  border: green solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
}

.pageination{
  color: white;
  margin: 10px;
}

.credit{
  text-align: center;
  color: white;
  font-family: DinCondL;
  letter-spacing: 3px;
  font-weight: 100;
  font-size: 14px;
}

.v-carousel__controls{
  background: transparent !important;
}
.v-carousel__controls .v-item-group{
  max-width: min-content !important;
  position: absolute;
  bottom: 15px;
  right: 15px;
}



.border-white{
  border-top:1px solid white;
}
.border-green{
  border-top:1px solid #19442A;
}

.NotoSerifTC{
  font-family: 'NotoSerifTC';
}

.MHeiHK{
  font-family: 'MHeiHK';
}

.georgia{
  font-family: Georgia, 'Times New Roman', Times, serif !important;
}

.CSong3HKM{
  font-family: "CSong3HKM" !important;
}

.NotoSerifTC{
  font-family: 'Noto Serif TC', serif;
}

</style>